<template>
	<div class="pagecont">
		<Header ref="headerbox" link="index" />
		<!--banner-开始-->
		<!-- height="480px" -->
		<!-- :style="{backgroundImage:'url('+ imageIndexbg +')'}" -->
		<div class="Indexbox" :style="{backgroundImage:darkmode?'url('+imageIndexdarkbg+')':'url('+imageIndexbg+')'}">
			<!-- indicator-position='none' -->
			<el-carousel ref="carousel" trigger="click" class="swiper-container banner ward " indicator-position='none'
				:initial-index="initIndex" @change="qhcarousel">
				<el-carousel-item v-for="(item, index) in banners" :key="index" class="swiper-wrapper">
					<div class="swiper-slide" :style="{backgroundImage:'url('+item.thumb+')'}">
						<div class="textBan IndxBan">
							<h2>{{item.title}}</h2>
							<h3>{{item.desc}}</h3>
						</div>
					</div>
				</el-carousel-item>
			</el-carousel>
			<!--banner-结束-->
			<article class="Huans Indsal ward">
				<section class="IndsalCont flexC fl-bet ward">
					<div class="Indsall flexC fl-bet">
						<div class="Indsallbox flexC">
							<!-- <span class="pciconfont icon-xiaolaba IndsallH"></span> -->
							<span class="IndsallH iconfontll icon-jurassic_radio "></span>
							<span class="Indsaltxt">{{$t('message.gonggao')}}</span>
						</div>
						<el-carousel height="30px" direction="vertical" indicator-position="none"
							class="swiper-container IndsallB">
							<el-carousel-item v-for="(item, index) in noticeList" :key="index" class="swiper-wrapper">
								<div @click.stop="showDiag(item, index)" class="swiper-slide">{{ item.title}}</div>
							</el-carousel-item>
						</el-carousel>
					</div>
					<!-- 	<a :href='`javascript:window.open("${kfurl}", "livechat", "height=630, width=600, toolbar= no,directions=no,alwaysRaised=yes,hotkeys =yes, menubar=no, scrollbars=no, resizable=no, location=no, status=no,top=100,left=300");`'
					class="IndsalKF Huans flexC"><span class="pciconfont icon-kefu"></span>
					<p>{{$t('footer.service')}}</p>
				</a> -->
					<nav class="slider-dots">
						<ul>
							<li @mouseleave="slidermouseleavefun(index)" @mouseover="slidermouseoverfun(index)"
								@click="sliderClick(index)" v-for="(item, index) in banners" :key="index" class="dot "
								:class="initIndex==index?'active':''"></li>
						</ul>
					</nav>
				</section>
			</article>

			<article class="Huans IndDK ward">
				<div class="oneTitle">{{$t('home.hotgametit')}}</div>
				<!--游戏-->
				<section class="IndDowbox">
					<el-row class="IndDow" :gutter="24" style="margin-left:-5px;margin-right:-5px;">
						<el-col :span="8" style="padding-left: 5px;padding-right: 5px;">
							<div class="game-content">
								<div class="softgame Huans enlarge carddh boxShadow"
									:class="DZdata.is_color==1?'gamebgcolor':''" @click="gogamedetail(DZdata)">
									<div class="softgameItem">
										<div class="softgameCont">
											<div class="IndGemH">{{DZdata.title}}</div>
											<div class="IndGemP">
												<!-- <p>{{$t('home.egamesdesc2')}}</p> -->
												<p>{{DZdata.desc}}</p>

											</div>
											<!-- 	<div v-if="DZdata.is_electron==1" class="IndGema">{{$t('home.gogamebtn')}}
											</div> -->
										</div>
										<div class="IndGemI"><img :src="DZdata.thumb"></div>
									</div>

								</div>
								<div class="softgamemain flexC">
									<!-- 							<div class="softiconbtn soft_flicon iconfontll icon-youjiantou1 "></div>
									<div class="softgamelist flexC">
										<div class="softgameitem">
											<img src="@/assets/pc/images/pic/slotxt1.png">
										</div>
										<div class="softgameitem">
											<img src="@/assets/pc/images/pic/slotxt2.png">
										</div>
										<div class="softgameitem">
											<img src="@/assets/pc/images/pic/slotxt1.png">
										</div>
										<div class="softgameitem">
											<img src="@/assets/pc/images/pic/slotxt2.png">
										</div>
									</div>
									<div class="softiconbtn soft_fricon iconfontll icon-youjiantou"></div> -->
									<el-carousel :loop="true" :autoplay="true" :interval="5000" arrow="always"
										indicator-position='none' height="78px">
										<el-carousel-item class="softgamelist flexC" v-for="(list, index) in eleList"
											:key="index">
											<div v-for="(itm,idx) in list" :key="idx" @click="enterGame(itm)"
												class="softgameitem">
												<!-- <img src="@/assets/pc/images/pic/slotxt2.png"> -->
												<img :src="itm.thumb">
											</div>

										</el-carousel-item>
									</el-carousel>

								</div>
							</div>
						</el-col>
						<el-col :span="8" style="padding-left: 5px;padding-right: 5px;">
							<div class="game-content">
								<div class="casinogame Huans enlarge carddh boxShadow"
									:class="ZRdata.is_color==1?'gamebgcolor':''" @click="gogamedetail(ZRdata)">
									<div class="hotgame">hot games</div>
									<div class="casinogameItem">
										<div class="casinogameCont">
											<div class="IndGemH">{{ZRdata.title}}</div>
											<div class="IndGemP">
												<!-- <p>{{$t('home.livedesc2')}}</p> -->
												<p>{{ZRdata.desc}}</p>

											</div>
											<!-- <div v-if="ZRdata.is_electron==1" class="IndGema">{{$t('home.gogamebtn')}}
											</div> -->
										</div>
										<div class="IndGemI"><img :src="ZRdata.thumb"></div>
									</div>
								</div>
								<div class="lotterygame Huans enlarge carddh boxShadow"
									:class="CPdata.is_color==1?'gamebgcolor':''" @click="gogamedetail(CPdata)">
									<div class="lotteryItem">
										<div class="lotterygameCont">
											<div class="IndGemH">{{CPdata.title}}</div>
											<div class="IndGemP">
												<!-- 	<p>{{$t('home.lotterydesc2')}}</p> -->
												<p>{{CPdata.desc}}</p>

											</div>
											<!-- <div v-if="CPdata.is_electron==1" class="IndGema">{{$t('home.gogamebtn')}}
											</div> -->
										</div>
										<div class="IndGemI"><img :src="CPdata.thumb"></div>
									</div>
								</div>
							</div>
						</el-col>
						<el-col :span="8" style="padding-left: 5px;padding-right: 5px;">
							<div class="IndApp Huans carddh boxShadow">
								<div class="ratebox flexC">
									<!-- score-template="{ratevalue}" show-score -->
									<el-rate v-model="ratevalue" disabled text-color="#ff9900">></el-rate>
									<h3 class="rateTxt">{{ratevalue}}</h3>
								</div>

								<div class="IndAppF flexC  Huans">
									<div class="IndAppM flexC fl-cen Huans">
										<!-- 下载二维码 -->
										<!-- <img src="@/assets/pc/images/pic/appewm.png"> -->
										<img :src="downCodeImage">
									</div>
									<div class="Huans IndAppFN">
										<p>{{$t('download.scantxt')}}</p>
										<div class="appxt_ul flexC">
											<div class="appxt_li">
												<span class="appxt_icon iconfontll icon-pingguo1"></span>
												<span class="appxt_txt">IOS</span>
											</div>
											<div class="appxt_li">
												<span class="appxt_icon iconfontll icon-anzhuo1"></span>
												<span class="appxt_txt">Android</span>
											</div>
										</div>
										<!-- <h3>iOS & Android</h3> -->
										<!-- <img @click="download()" src="@/assets/pc/images/znot/IndAppS01.png"> -->
										<!-- <p>{{$t('download.version')}}: V{{version}}</p> -->
									</div>
								</div>
								<div class="IndAppbtm flexC fl-bet Huans">
									<div class="IndAppT">
										<h3>{{$t('download.downtext')}}</h3>
										<p>{{$t('download.downdesc')}}</p>
									</div>
									<div class="IndAppFI">
										<img src="@/assets/pc/images/znot/IndAppT01.png">
									</div>
								</div>

							</div>
						</el-col>
					</el-row>
				</section>
				<!--游戏-->
				<section class="IndDowbox">
					<el-row class="IndGem " :gutter="24" style="margin-left:-5px;margin-right:-5px;">
						<el-col :span="6" style="padding-left: 5px;padding-right: 5px;">
							<div class="IndGemK IndGem-ZR Huans enlarge carddh boxShadow"
								:class="QPdata.is_color==1?'gamebgcolor':''" @click="gogamedetail(QPdata)">
								<div class="hotgame hotgameleft">hot games</div>
								<div class="ZRGemItem">
									<div class="IndGemIl"><img :src="QPdata.thumb"></div>
									<div class="IndGemN">
										<div class="IndGemH">{{QPdata.title}}</div>
										<div class="IndGemP">
											<p>{{QPdata.desc}}</p>
											<!-- <p>{{$t('home.Chesscardsdesc3')}}</p>
											<p>{{$t('home.Chesscardsdesc4')}}</p> -->
										</div>

									</div>

								</div>
								<!-- 	<div v-if="QPdata.is_electron==1" class="IndGema">{{$t('home.gogamebtn')}}</div> -->
								<div class="IndGema">{{$t('home.Enter')}}</div>
							</div>
						</el-col>
						<el-col :span="12" style="padding-left: 5px;padding-right: 5px;">
							<div class="IndGemK IndGem-DZ Huans enlarge carddh boxShadow"
								:class="TYdata.is_color==1?'gamebgcolor':''" @click="gogamedetail(TYdata)">
								<div class="hotright">hot games</div>
								<div class="DZGemItem">
									<div class="IndGemIl"><img :src="TYdata.thumb"></div>
									<div class="IndGemN">
										<div class="IndGemH">{{TYdata.title}}</div>
										<div class="IndGemP">
											<!-- 	<p>{{$t('home.sportdesc2')}}</p> -->
											<p>{{TYdata.desc}}</p>
										</div>

									</div>

								</div>
								<!-- <div v-if="TYdata.is_electron==1" class="IndGema">{{$t('home.gogamebtn')}}</div> -->
								<div class="IndGema">{{$t('home.Enter')}}</div>
							</div>
						</el-col>
						<el-col :span="6" style="padding-left: 5px;padding-right: 5px;">
							<div class="IndGemK IndGem-qd Huans enlarge carddh boxShadow"
								:class="BYdata.is_color==1?'gamebgcolor':''" @click="gogamedetail(BYdata)">
								<div class="qdGemNItem">
									<div class="IndGemN">
										<div class="IndGemH">{{BYdata.title}}</div>
										<div class="IndGemP">
											<!-- <p>{{$t('home.fishdesc2')}}</p> -->
											<p>{{BYdata.desc}}</p>
										</div>
										<!-- <div v-if="BYdata.is_electron==1" class="IndGema">{{$t('home.gogamebtn')}}</div> -->
									</div>
									<div class="IndGemI"><img :src="BYdata.thumb"></div>
								</div>
							</div>
							<div class="IndGemK IndGem-qd1 Huans enlarge carddh boxShadow" style="margin-top: 10px;">
								<div class="qd1GemNItem">
									<div class="IndGemIl"><img src="@/assets/pc/images/pic/yu2.png"></div>
									<div class="IndGemN">
										<div class="IndGemH">Coming soon</div>
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
				</section>
				<!-- 优惠 -->
				<section class="IndDowbox">
					<div class="oneTitle">{{$t('message.zuixin')}}{{$t('message.activity')}}</div>
					<el-row class="Indyhhd IndGem" :gutter="24" style="margin-left:-5px;margin-right:-5px;">
						<el-col v-for="(item, index) in actList" :key="index" :span="8"
							style="padding-left: 5px;padding-right: 5px;">
							<div @click.stop="goactdetail(item)" class="youitem Huans enlarge carddh boxShadow">
								<div class="hotgame hothsleft">hot games</div>
								<div class="youimg"><img :src="item.thumb"></div>
								<div class="youcont flexC fl-bet">
									<div class="youtitle">{{item.title}}</div>
									<div class="IndGema">{{$t('message.Detail')}}</div>
								</div>

							</div>
						</el-col>


					</el-row>
				</section>

			</article>
		</div>
		<!-- 公告详情 -->
		<el-dialog :title="msgdetail.type" :visible.sync="dialogVisible" @close="closedialog">
			<div class="fw" style="margin-bottom:5px;">{{msgdetail.title}}</div>
			<div>{{msgdetail.desc}}</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="closedialog">{{$t('message.close')}}</el-button>
			</span>
		</el-dialog>

		<!-- 重要提醒弹窗 -->
		<el-dialog :title="$t('home.tiptitle')" width="500px" :visible.sync="dialogTableVisible"
			:close-on-click-modal="false" class="zytxDemo ">
			<ul class="TcNewK Huans">
				<li v-for="(item, index) in tipsList">
					<a href="JavaScript:;" class="TcNewa flexC fl-bet">
						<!-- 	<p>1.内容内fasdfasd发大水发斯加芬 稍等返款... </p><span>12/03 22:00 2022</span> -->
					</a>
					<div class="TcNewN Huans">{{item.description}}</div>
				</li>
			</ul>
			<!-- <div class="TcGGN Huans" v-for="(item, index) in tipsList">
        <p>{{item.description}}</p>
      </div> -->
			<a href="JavaScript:;" @click="closeDemo" class="TcGGa colse">{{$t('home.tipclose')}}</a>
			<div class="TcGGF Huans flexC fl-end">
				<label @click="handtipscheck()" class="TC-lab flexC"><input type="checkbox" name="checkbox"
						v-model="isTipsflag" />
					<p>{{$t('home.tipflag')}}</p>
				</label>
			</div>
		</el-dialog>
		<!-- 重要提醒弹窗end -->
		<Footer />
	</div>
</template>
<script>
	import Header from '@/components/pc/public/Header';
	import Footer from '@/components/pc/public/Footer';
	import {
		queryConfig,
		querypcIndex,
		queryactivitys,
		queryelectrons,
		queryelectronindex,
		queryIndexBanners,
		getAds,
		queryNotices,
		getIndexgame,
		getUserInfo,
		Entergame,
		getPopNotice
	} from "@/api/urls";
	export default {
		name: 'pcindex',
		components: {
			Header,
			Footer
		},
		data() {
			return {
				isLogin: false, //是否登录
				darkmode: false, //是否夜间模式
				imageIndexbg: "", //首页白天背景
				imageIndexdarkbg: "", //首页黑夜背景
				banners: [{
					path: require('@/assets/pc/images/sports/ban1.jpg')
				}, {
					path: require('@/assets/pc/images/sports/ban1.jpg')
				}], //轮播图
				initIndex: 0,
				noticeList: [], // 公告
				ZRdata: {},
				DZdata: {},
				TYdata: {},
				CPdata: {},
				QPdata: {},
				BYdata: {},
				actList: [], //优惠
				eleList: [], //电子游戏
				dialogTableVisible: false, //是否打开提醒弹窗
				tipsList: [], //重要提醒
				isTipsflag: false, //是否今日不提醒
				isflag: false, //倒计时是否结束
				Config: {}, //下载app
				downCodeImage: '', //下载二维码
				kfurl: "", //客服链接
				enddate: "", //存的当天倒计时结束日期时间
				version: "1.0.0", //版本号
				ratevalue: 4.9,
				gameDisabled: false, //进入游戏防止重复提交
				dialogVisible: false,
				msgdetail: {}, //公告详情1


			}
		},
		computed: {

		},
		created() {
			var that = this;
			that.getpcIndex()
			that.getAnnounce()
			that.getBanners()
			that.getactivitys()
			that.getelectronindex()
			// this.getAds()
			that.getSystem()
			// that.getBonusInfo() //首页弹框信息
			that.getPopNotice() //首页弹框公告
			// 判断是否登录
			console.log(that.$store.getters['getToken'], "判断是否登录")
			if (that.$store.getters['getToken'] != '') {
				that.isLogin = true;

			} else {
				that.isLogin = false;
			}
			// 获取黑白模式
			var darkmodeval = that.$store.state.darkmode;
			console.log("darkmodeval", darkmodeval)
			if (darkmodeval != null) {
				that.darkmode = darkmodeval;
			}
			// 获取弹窗是否今日不提醒
			var isTipsflag = that.$store.state.isTipsflag;
			that.isTipsflag = isTipsflag;
			var enddate = that.$store.state.enddate;
			that.enddate = enddate; //当天倒计时结束日期时间
			console.log(that.isTipsflag, that.enddate, "今日不提醒")
			if (!that.isTipsflag) {
				setTimeout(function() {
					// that.dialogTableVisible = true;
				}, 2000);
			} else {
				let time = setInterval(() => {
					if (that.isflag == true) {
						clearInterval(time)
					}
					that.countTime() //当天倒计时
				}, 1000)
			}
		},

		methods: {
			// 首页内容
			getpcIndex() {
				var params = {
					'lang': this.$store.state.lang,
				};
				querypcIndex(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						console.log(data)
						if (data.length > 0) {
							for (var i in data) {
								if (data[i].type == "真人") {
									this.ZRdata = data[i];
								}
								if (data[i].type == "电子") {
									this.DZdata = data[i];
								}
								if (data[i].type == "体育") {
									this.TYdata = data[i];
								}
								if (data[i].type == "彩票") {
									this.CPdata = data[i];
								}
								if (data[i].type == "棋牌") {
									this.QPdata = data[i];
								}
								if (data[i].type == "捕鱼") {
									this.BYdata = data[i];
								}
							}
						}
						// this.noticeList = data;
					}
				})
			},
			// 首页推荐优惠活动
			getactivitys() {
				var params = {
					'lang': this.$store.state.lang,
				};
				queryactivitys(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						// console.log(data)
						this.actList = data;
					}
				})
			},
			// 优惠详情
			goactdetail(item) {
				var that = this;
				that.$router.push({
					name: 'pcacvdetails',
					// path: '/pcacvdetails',
					query: {
						id: item.id
					}
				})

			},
			// 首页推荐推荐电子游戏
			getelectronindex() {
				var params = {
					'lang': this.$store.state.lang,
				};
				queryelectronindex(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						// console.log(data)
						this.eleList = data;
						let newDataList = []
						let current = 0
						if (this.eleList && this.eleList.length > 0) {
							for (let i = 0; i <= this.eleList.length - 1; i++) {
								if (i % 4 !== 0 || i === 0) {
									if (!newDataList[current]) {
										newDataList.push([this.eleList[i]])
									} else {
										newDataList[current].push(this.eleList[i])
									}
								} else {
									current++
									newDataList.push([this.eleList[i]])
								}
							}
						}
						this.eleList = [...newDataList]
						console.log(this.eleList, "this.eleList")
					}
				})
			},
			//公告列表
			getAnnounce() {
				var params = {
					'type': '首页公告', //首页公告，代理公告，游戏公告
					'lang': this.$store.state.lang,
				};
				queryNotices(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						this.noticeList = data;
					}
				})
			},
			//首页弹窗公告
			getPopNotice() {
				getPopNotice().then(({
					code,
					data
				}) => {
					if (code === 200) {
						// this.$store.commit('setIslookpop',false)
						var Islookpop = this.$store.state.islookpop; //获取显示状态
						console.log(Islookpop, "获取是否已显示弹窗公告状态")
						if (data != "" && (Islookpop == undefined || !Islookpop)) {
							this.$alert(data, '', {
								confirmButtonText: '确定',
								callback: action => {
									// on close
									this.$store.commit('setIslookpop', true)
									console.log("点击了关闭")
								}
							});
						}
						// this.announces = data;
					}
				})
			},
			//首页弹框信息
			getBonusInfo() {
				// queryBonusInfo().then(({
				//   code,
				//   data
				// }) => {
				//   if (code === 200) {
				//     this.tipsList = data;
				//   }
				// })
			},
			// 进入详情页
			gogamedetail(item) {
				// if (item.is_electron == 1) {
				// 	// 是否是电子游戏
				// 	this.enterGame(item)
				// 	return false
				// }
				if (item.type == "真人") {
					this.$router.push({
						path: '/pconsite',
					})
					return false
				}
				if (item.type == "电子") {
					this.$router.push({
						path: '/pcegames',
					})
					return false
				}
				if (item.type == "体育") {
					this.$router.push({
						path: '/pcsports',
					})
					return false
				}
				if (item.type == "彩票") {
					this.$router.push({
						path: '/pclottery',
					})
					return false
				}
				if (item.type == "棋牌") {
					this.$router.push({
						path: '/pcChess',
					})
					return false
				}
				if (item.type == "捕鱼") {
					this.$router.push({
						path: '/pcfishing',
					})
					return false
				}
			},
			//进入游戏判断
			enterGame(item) {
				//判断是否登录
				if (this.$store.state.token == '') {
					this.$message.error(this.$t('message.plogin'));
					return false;
				}
				// 0维护 1正常
				if (item.status == 0) {
					this.$message.error(this.$t('message.gamenoIndesc'));
					return false;
				}

				// 进入游戏防止重复提交
				// console.log(this.gameDisabled,"gameDisabled")
				if (!this.gameDisabled) {
					this.gameDisabled = true;
					this.$toast({
						type: 'loading',
						message: this.$t('message.loading'),
						duration: 0,
						forbidClick: true, //禁止背景点击
					});
					//直接进入游戏
					var params = {
						'type': item.apiname,
						'gtype': item.game_type,
						'url': item.url,
						'form': 2, //1wap端 2pc端
					};
					Entergame(params).then(({
						code,
						data,
						msg
					}) => {
						if (code === 200) {
							// pg/pt电子类型，返回的就是html
							if (item.apiname == "PG" || item.apiname == "PT") {
								// this.$router.push({
								// 	name: 'pchtmlCont',
								// 	params: {
								// 		htmlContent: data
								// 	}
								// })
								// 打开新页面
								let pathInfo = this.$router.resolve({
									name: 'linkpage',
									query: {
										pageurl: data,
										pagetype: 2
									}
								})
								window.open(pathInfo.href, '_blank')
							} else {
								// 打开新页面
								let pathInfo = this.$router.resolve({
									name: 'linkpage',
									query: {
										pageurl: data,
										pagetype: 1
									}
								})
								window.open(pathInfo.href, '_blank')
							}

							this.$toast.clear();
							this.gameDisabled = false;
							setTimeout(() => {
								this.$refs.headerbox.getUserInfo(); //更新头部钱包金额
							}, 2000)
						} else {
							this.$toast.clear();
							this.$message.error(msg);
							this.gameDisabled = false;
						}
					}).catch((err) => {
						// console.log("err",err);
						this.gameDisabled = false;
					});

				}
			},
			// 切换幻灯片
			qhcarousel(index) {
				// console.log(index)
				this.initIndex = index;
			},
			sliderClick(index) {
				console.log(index)
				this.initIndex = index;
				this.$refs.carousel.setActiveItem(index);
			},
			slidermouseoverfun(index) {
				// console.log(index)
				this.initIndex = index;
				this.$refs.carousel.setActiveItem(index);
			},
			slidermouseleavefun(index) {
				// console.log(index)
				this.initIndex = index;
				this.$refs.carousel.setActiveItem(index);
			},
			// 勾选不勾选今日不提醒
			handtipscheck() {
				var that = this;
				that.isTipsflag = !that.isTipsflag;
				// console.log(that.isTipsflag,"今日不提醒")
				that.$store.commit('setIsTipsflag', that.isTipsflag)
				if (that.isTipsflag) {
					that.getToday()
					let time = setInterval(() => {
						if (that.isflag == true) {
							clearInterval(time)
						}
						that.countTime() //当天倒计时
					}, 1000)
				} else {
					that.enddate = '';
					that.$store.commit('setEnddate', that.enddate)
				}
			},
			// 获取当天时间
			getToday() {
				var date = new Date();
				var nowYear = date.getFullYear(); //获取当前年
				var nowMonth = date.getMonth() + 1; //获取当前月
				if (parseInt(nowMonth) < 10) {
					nowMonth = '0' + nowMonth;
				}
				var nowDay = date.getDate(); //获取当前日
				if (parseInt(nowDay) < 10) {
					nowDay = '0' + nowDay;
				}
				var startTime = "00:00:00";
				var lastTime = "23:59:59"; //"23:59:59"
				var endTime = nowYear + '-' + nowMonth + '-' + nowDay + ' ' + lastTime;
				this.enddate = endTime;
				this.$store.commit('setEnddate', this.enddate)
				// console.log(this.enddate, "存结束时间")
			},
			// 当天倒计时
			countTime() {
				//获取当前时间
				var date = new Date();
				var now = date.getTime(); //获取当前时间戳

				//设置截止时间
				var endTime = this.enddate; //"2018-10-22 23:23:23"
				// console.log(endTime, 'endTime开始倒计时');
				var endDate = new Date(endTime);
				var end = endDate.getTime();
				//时间差
				var leftTime = end - now; ////截止时间减去当前时间
				//定义变量 d,h,m,s保存倒计时的时间
				// console.log(leftTime,"leftTime");
				if (leftTime >= 0) { ////判断剩余倒计时时间如果大于0就执行倒计时否则就结束
					// var d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
					this.h = Math.floor(leftTime / 1000 / 60 / 60 % 24);
					this.m = Math.floor(leftTime / 1000 / 60 % 60);
					this.s = Math.floor(leftTime / 1000 % 60);
					// console.log(this.h+'：'+this.m+'：'+this.s,"当天倒计时");
				} else {
					this.isflag = true;
					this.isTipsflag = false; //倒计时结束今日提醒
					this.enddate = "";
					this.$store.commit('setIsTipsflag', this.isTipsflag)
					this.$store.commit('setEnddate', this.enddate)
					// this.dialogTableVisible = true;
					console.log("当天倒计时结束了");
				}

				//递归每秒调用countTime方法，显示动态时间效果
				// setTimeout(this.countTime, 1000);
			},
			//轮播图列表
			getBanners() {
				var params = {
					'type': '首页', //'首页''游戏页面'、代理页面、引导页、分享页、体育页、真人页、棋牌页、电子页、彩票页、捕鱼页,
					'lang': this.$store.state.lang,
					'form': 2, //1wap端 2pc端
				};
				queryIndexBanners(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						this.banners = data;
					}
				})
			},
			// 获取广告图
			getAds() {
				var params = {
					'type': '视频', //类型：可选值：视频、体育
					'lang': this.$store.state.lang,
					'form': 2, //1wap端 2pc端
				};
				getAds(params).then(({
					code,
					data,
					msg
				}) => {
					if (code === 200) {
						this.AdsList = data;
					} else {
						this.$message.error(msg)
					}
				})
			},
			//游戏列表
			getGameList() {
				// queryGameTypeList().then(({
				//   code,
				//   data
				// }) => {
				//   if (code === 200) {
				//     data.map((item, index) => {
				//       if (item['name'] == this.$store.state.lang) {
				//         this.games = item['map'];
				//       }
				//     })
				//   }
				// })
			},
			// 系统消息详情
			showDiag(item, index) {
				this.msgdetail = item;
				this.dialogVisible = true;
				// console.log("系统消息详情")
			},
			closedialog() {
				console.log("关闭q")
				this.dialogVisible = false;
			},
			// 关闭重要提醒弹窗
			closeDemo() {
				var that = this;
				that.dialogTableVisible = false;
			},
			// 显示表情列表
			showbqdemo() {
				var that = this;
				if (!that.isshowbq) {
					that.isshowbq = true;
				} else {
					that.isshowbq = false;
				}
			},
			// 选择tab
			clickstab(item, index) {
				var that = this;
				that.stabidx = index;
				that.stabid = item.id;
				that.IndViditem = that.IndVidList[0];
				// 选择视频
				// that.videoSrc=item.title;

			},

			//获取系统变量
			getSystem() {
				var params = {
					'lang': this.$store.state.lang,
				}
				queryConfig(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						this.Config = data;
						this.downCodeImage = data.download_qrcode;
						this.imageIndexbg = data.index_background2; //首页白天背景
						this.imageIndexdarkbg = data.index_black_background2; //首页黑夜背景
						// console.log(data, "data")
					}
				})
			},

		}
	}
</script>


<style scoped>
	/* 重要提醒弹窗 */
	.zytxDemo /deep/ .el-dialog {
		border-radius: 10px;
	}

	.zytxDemo /deep/ .el-dialog__header {
		padding: 20px 20px;
		background: #025be8;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
	}

	.zytxDemo /deep/ .el-dialog__title {
		color: #ffffff;
	}

	.zytxDemo /deep/ .el-dialog__headerbtn .el-dialog__close {
		color: #ffffff;
		font-size: 22px;
	}

	.zytxDemo /deep/ .el-dialog__body {
		padding: 0 0;
	}

	.danmu-box .item .text_con .text_conbox /deep/ .emoji_img {
		width: 20px;
		height: 20px;
		vertical-align: middle;
	}

	.TcNewN {
		padding: 6px 0;
	}

	.IndVidRN_scroll {
		overflow: auto;
		height: calc(100% - 5px);
	}
</style>


// WEBPACK FOOTER //
// src/components/pc/index.vue